import { REMOVE_FROM_CART_ERROR, REMOVE_FROM_CART_REQUEST, REMOVE_FROM_CART_SUCCESS, } from '../types';
import { useHelper } from '../helpers';
import { getOrLoadCart } from './get-or-load-cart';
export const removeFromCartRequest = (lineItemId) => {
    return {
        type: REMOVE_FROM_CART_REQUEST,
        lineItemId: lineItemId,
    };
};
export const removeFromCartSuccess = ({ cart, product, quantity, sku, }) => {
    return {
        type: REMOVE_FROM_CART_SUCCESS,
        data: cart,
        product,
        quantity,
        sku,
    };
};
export const removeFromCartError = (error, meta = {}) => {
    return {
        type: REMOVE_FROM_CART_ERROR,
        error: true,
        meta,
        payload: error,
    };
};
export const removeFromCart = (options) => {
    return async (dispatch, getState, { chord }) => {
        const { lineItemId, product } = options;
        const { withCart } = useHelper(dispatch, getState);
        try {
            dispatch(removeFromCartRequest(lineItemId));
            const { data: cart } = await getOrLoadCart(dispatch, getState);
            await withCart(chord.oms.removeLineItem)(null, lineItemId);
            const updatedCart = await withCart(chord.oms.getOrder)();
            const removedLineItem = cart.lineItems.find((lineItem) => lineItem.id === lineItemId);
            const sku = removedLineItem?.variant?.sku;
            const quantity = -removedLineItem.quantity;
            dispatch(removeFromCartSuccess({
                cart: updatedCart,
                product,
                quantity,
                sku,
            }));
            return updatedCart;
        }
        catch (error) {
            dispatch(removeFromCartError(error, { lineItemId }));
            throw error;
        }
    };
};
